import { Link } from 'react-router-dom';
import { Icons } from '@/src/modules/components/Icons';
import { useCollections } from '@/src/modules/catalog/useCollections';
import { CatalogPricingProvider } from '@/src/modules/catalog/useCatalogPricingMode';
import { ProductCard } from '@/src/modules/pages/catalog/ProductCard';

/** Dashboard shows the first N catalog Collections; "Browse all designs" opens the full `/catalog`. */
export const DASHBOARD_CATALOG_LIMIT = 6;

const GRID_CLASSES = 'grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6';

function BrowseCatalogContent() {
  const { data, loading, error, reload } = useCollections({
    pageSize: DASHBOARD_CATALOG_LIMIT,
    sort: 'display_order',
  });

  return (
    <section className="mb-12">
      <div className="flex items-center justify-between mb-4">
        <h2 className="text-xl font-bold text-on-surface">Browse Invitation Designs</h2>
        <Link to="/catalog" className="text-sm font-semibold text-primary hover:underline flex items-center gap-1">
          Browse all designs
          <Icons.ChevronRight size={16} />
        </Link>
      </div>

      {loading && (
        <div className={GRID_CLASSES} data-testid="catalog-section-loading">
          {Array.from({ length: 3 }).map((_, i) => (
            <div key={i} className="h-72 rounded-[2rem] bg-surface border border-outline-variant/30 animate-pulse" />
          ))}
        </div>
      )}

      {!loading && error && (
        <div className="flex flex-col items-center gap-3 rounded-[2rem] border border-outline-variant/30 bg-surface p-10 text-center">
          <p className="text-sm font-medium text-status-failed">We couldn’t load designs. Please try again.</p>
          <button type="button" onClick={() => void reload()} className="text-sm font-semibold text-primary hover:underline">
            Retry
          </button>
        </div>
      )}

      {!loading && !error && data && data.length === 0 && (
        <div className="rounded-[2rem] border border-outline-variant/30 bg-surface p-10 text-center text-on-surface-variant">
          No designs available yet — check back soon.
        </div>
      )}

      {!loading && !error && data && data.length > 0 && (
        <div className={GRID_CLASSES}>
          {data.map((product) => (
            <ProductCard key={product.id} product={product} />
          ))}
        </div>
      )}
    </section>
  );
}

export function BrowseCatalogSection() {
  return (
    <CatalogPricingProvider>
      <BrowseCatalogContent />
    </CatalogPricingProvider>
  );
}
